import { render, staticRenderFns } from "./contract-preparation.vue?vue&type=template&id=36cfb880&scoped=true&"
import script from "./contract-preparation.vue?vue&type=script&lang=js&"
export * from "./contract-preparation.vue?vue&type=script&lang=js&"
import style0 from "./contract-preparation.vue?vue&type=style&index=0&id=36cfb880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cfb880",
  null
  
)

export default component.exports